import React, { useState, useRef } from "react";
import { Row, Col, UncontrolledTooltip } from "reactstrap";
import Code from "./Code";
import TextInstructions from "./TextInstructions";
import { postRunbook } from "store/actions";
import { useDispatch } from "react-redux";

const CreateRunbook = ({ alert_log_id }) => {
  const dispatch = useDispatch();
  const [diagnosticInstructions, setDiagnosticInstructions] = useState([]);
  const [recoveryInstructions, setRecoveryInstructions] = useState([]);
  const [addDiagnosticInstruction, setAddDiagnosticInstruction] = useState(false);
  const [addRecoveryInstruction, setAddRecoveryInstruction] = useState(false);
  const [fieldEmpty, setFieldEmpty] = useState('');
  const [diagnosticIndex, setDiagnosticIndex] = useState(0);
  const [recoveryIndex, setRecoveryIndex] = useState(0);

  const text = useRef();
  const code = useRef();
  const name = useRef();
  const description = useRef();
  const conclusion = useRef();

  const saveChanges = () => {
    if(name.current.value !== '' && description.current.value !== '' && conclusion.current.value !== '' && diagnosticInstructions.length > 0 && recoveryInstructions.length > 0){
      let data = {
        name: name.current.value,
        description: description.current.value,
        conclusion: conclusion.current.value,
        alert_log_id: alert_log_id,
        diagnostic_instructions: diagnosticInstructions,
        recovery_instructions: recoveryInstructions
      };
  
      dispatch(postRunbook(data));
      setTimeout(() => {
        location.reload()
      }, 1000)

    } else {
      if(description.current.value === ''){
        setFieldEmpty('desc');
      } else if(name.current.value === ''){
        setFieldEmpty('name')
      } else if(diagnosticInstructions.length < 1) {
        setFieldEmpty('diagnostic')
      } else if(recoveryInstructions.length < 1){
        setFieldEmpty('recovery')
      }
    } 
  };

  function setDiagnosticCode(data, type) {
    if (type === 'diagnostic') {
      const updatedInstructions = diagnosticInstructions.map((item) => {
        if (item.id === data.id) {
          return { ...item, code: data.code };
        }
        return item;
      });
      setDiagnosticInstructions(updatedInstructions);
    }
  }
  
  function setRecoveryCode(data, type) {
    if (type === 'recovery') {
      const updatedInstructions = recoveryInstructions.map((item) => {
        if (item.id === data.id) {
          return { ...item, code: data.code };
        }
        return item;
      });
      setRecoveryInstructions(updatedInstructions);
    }
  }
  
  function setDiagnosticText(data, type) {
    if (type === 'diagnostic') {
      const updatedInstructions = diagnosticInstructions.map((item) => {
        if (item.id === data.id) {
          return { ...item, instruction: data.instruction };
        }
        return item;
      });
      setDiagnosticInstructions(updatedInstructions);
    }
  }
  
  function setRecoveryText(data, type) {
    if (type === 'recovery') {
      const updatedInstructions = recoveryInstructions.map((item) => {
        if (item.id === data.id) {
          return { ...item, instruction: data.instruction };
        }
        return item;
      });
      setRecoveryInstructions(updatedInstructions);
    }
  }
  

  const deleteDiagnosticInstruction = (itemToDelete) => {
    const updatedInstructions = diagnosticInstructions.filter(item => item !== itemToDelete);
    setDiagnosticInstructions(updatedInstructions);
  };

  const deleteRecoveryInstruction = (itemToDelete) => {
    const updatedInstructions = recoveryInstructions.filter(item => item !== itemToDelete);
    setRecoveryInstructions(updatedInstructions);
  };

  const addInstruction = (type) => {
  if (text.current.value !== '') {
    let data = {
      code: code.current.value,
      instruction: text.current.value,
    };

    if (type === 'recovery') {
      data['id'] = recoveryIndex;
      const updatedInstructions = [...recoveryInstructions, data];
      setRecoveryInstructions(updatedInstructions);
      setRecoveryIndex(recoveryIndex + 1);
    } else if(type === 'diagnostic'){
      data['id'] = diagnosticIndex;
      const updatedInstructions = [...diagnosticInstructions, data];
      setDiagnosticInstructions(updatedInstructions);
      setDiagnosticIndex(diagnosticIndex + 1)
    }
    text.current.value = "";
    code.current.value = "";
    setAddDiagnosticInstruction(false);
    setAddRecoveryInstruction(false);
  } else {
    setFieldEmpty('instruction');
    if (text.current.value === '') {
      setFieldEmpty('text');
    }
  }
};

  return (
    <React.Fragment>
      <div className="mx-auto" style={{ width: "97%" }}>
        <h4>Create a Runbook</h4>
        <div className="w-100 mt-4">
          <Row className="d-flex">
            <Col className="my-2" lg={2}>Runbook Name</Col>
            <Col className="my-2" lg={10}><input required onChange={() => setFieldEmpty('')} placeholder="Name" ref={name} type="text" className="w-100 form-control" /></Col>
            <Col lg={2}></Col>
            <Col lg={10}>{fieldEmpty === 'name' && <span className="text-danger">Runbook name cannot be empty!</span>}
            </Col>
          </Row>
          <Row className="d-flex">
            <Col className="my-2" lg={2}>Description</Col>
            <Col className="my-2" lg={10}><textarea required placeholder="Description" onChange={() => setFieldEmpty('')} ref={description} className="w-100 form-control" /></Col>
            <Col lg={2}></Col>
            <Col lg={10}>{fieldEmpty === 'desc' && <span className="text-danger">Description cannot be empty!</span>}</Col>
          </Row>

          <h4 className="my-4">Diagnostics</h4>

          {diagnosticInstructions?.map((item, index) => (
            <div key={index}>
              <div className="d-flex justify-content-end">
                <button 
                    id={`deleteDiagnostic${index}`} 
                    onClick={() => deleteDiagnosticInstruction(item)} 
                    className="btn btn-primary bg-transparent border-0 bx bx-x font-size-14">
                  </button>
                  <UncontrolledTooltip placement="top" target={`deleteDiagnostic${index}`}>Delete step</UncontrolledTooltip>
              </div>
                <TextInstructions 
                  index={index} 
                  textInstruction={item?.instruction} 
                  editable={true} 
                  id={index}
                  sendDataToParent={setDiagnosticText} 
                  type="diagnostic"
                  code={item?.code}
                  runbook_id={item?.runbook_id}
                />
              <Code code={item?.code} id={index} editable={true} sendDataToParent={setDiagnosticCode} type="diagnostic" />
            </div>
          ))}
          {addDiagnosticInstruction &&
            <>
              <Row className="mt-4 mb-2">
                <Col lg={2}>
                  <p className="text-white font-size-14">
                  Step {diagnosticIndex+1}  
                  </p>
                </Col>
              </Row>
              <Row className="d-flex">
                <Col className="my-2" lg={2}>Instruction</Col>
                <Col className="my-2" lg={10}><input onChange={() => setFieldEmpty('')} required placeholder="Text" ref={text} type="text" className="w-100 form-control" /></Col>
                <Col lg={2}></Col>
                <Col lg={10}>{fieldEmpty === 'text' && <span className="text-danger">Text instruction cannot be empty!</span> }</Col>
              </Row>
              <Row className="d-flex">
                <Col className="my-2" lg={2}>Code</Col>
                <Col className="my-2" lg={10}><input onBlur={() => addInstruction('diagnostic')} onChange={() => setFieldEmpty('')} required placeholder="Code" ref={code} className="w-100 form-control" /></Col>
                <Col lg={2}></Col>
                <Col lg={10}>{fieldEmpty === 'code' ? <span className="text-danger">Code cannot be empty!</span> : fieldEmpty === 'instruction' && <span>Please enter instructions</span>}</Col>
              </Row>
            </>
          }
            <div className="d-flex gap-2 align-items-center my-2"><button className="btn btn-primary" onClick={() => {setAddDiagnosticInstruction(true)} }>+</button>
                <span>Add diagnostic instruction</span>
                <div>{fieldEmpty === 'diagnostic' && <span className="text-danger">Add instruction</span>} </div>
            </div> 
        </div>

        <h4 className="my-4">Recovery</h4>
        {recoveryInstructions?.map((item, index) => (
          <div key={index}>
            <div className="d-flex justify-content-end">
                  <button 
                    id={`deleteRecovery${index}`} 
                    onClick={() => deleteRecoveryInstruction(item)} 
                    className="btn btn-primary bg-transparent border-0 bx bx-x font-size-14">
                  </button>
                  <UncontrolledTooltip placement="top" target={`deleteRecovery${index}`}>Delete step</UncontrolledTooltip>
            </div>
              <TextInstructions
                index={index}
                textInstruction={item?.instruction}
                editable={true}
                id={index}
                sendDataToParent={setRecoveryText}
                type="recovery"
                code={item?.code}
                runbook_id={item?.runbook_id}
              />
            <Code code={item?.code} id={index} editable={true} sendDataToParent={setRecoveryCode} type="recovery" />
          </div>
        ))}
        {addRecoveryInstruction &&
          <>
            <Row className="mt-4 mb-2">
              <Col lg={2}>
              <p className="text-white font-size-14">
              Step {recoveryIndex+1}  
              </p>
              </Col>
            </Row>
            <Row className="d-flex">
              <Col className="my-2" lg={2}>Instruction</Col>
              <Col className="my-2" lg={10}><input onChange={() => setFieldEmpty('')} required placeholder="Text" ref={text} type="text" className="w-100 form-control" /></Col>
              <Col lg={2}></Col>
              <Col lg={10}>{fieldEmpty === 'text' && <span className="text-danger">Text instruction cannot be empty!</span>}</Col>
            </Row>
            <Row className="d-flex">
              <Col className="my-2" lg={2}>Code</Col>
              <Col className="my-2" lg={10}><input onBlur={() => addInstruction('recovery')} onChange={() => setFieldEmpty('')} required placeholder="Code" ref={code} className="w-100 form-control" /></Col>
              <Col lg={2}></Col>
            </Row>
          </>
        }
  
        <div className="d-flex gap-2 align-items-center my-2"><button className="btn btn-primary" onClick={() => {setAddRecoveryInstruction(true)} }>+</button>
          <span>Add Recovery instruction</span>
          <div>{fieldEmpty === 'recovery' && <span className="text-danger">Add instruction</span>} </div>
        </div> 

        <Row className="d-flex">
          <Col className="my-2" lg={2}>Conclusion</Col>
          <Col className="my-2" lg={10}><textarea placeholder="Conclusion" ref={conclusion} className="w-100 form-control" /></Col>
          <Col lg={10}>{fieldEmpty === 'conclusion' && <span className="text-danger">Conclusion cannot be empty!</span>}</Col>
        </Row>
        <button type="submit" onClick={() => saveChanges()} className="btn btn-primary">Save changes</button>
      </div>
    </React.Fragment>
  );
}

export default CreateRunbook;
